export const chartColorBar = {
    chartLayout: {
        margin: { t: 7, r: 0, b: 35, l: 30 },
        font: { size: 12 },
        bargap: 0.15,
        bargroupgap: 0.1,
    },
    yAxisRange: [0, 105],
    annotationMargin: 3.5,
    tickColor: '#e4e4e4',
    tickFont: {
        family: 'Roboto, Arial, Helvetica, sans-serif',
        size: 12,
        color: '#7f7f7f'
    },
    zeroLineColor: '#e4e4e4',
    currencySign: {  USD: '$', EUR: '€' },
    barColor: '#5b74a5',
    hoverlabel: {
        bgcolor: '#4a4a4a',
        bordercolor: '#4a4a4a',
        font: {
            color: '#ffffff',
            family: 'Roboto, Arial, Helvetica, sans-serif',
            size: 12
        },
        align: 'left'
    }
};
